import styled from 'styled-components'
import { colors } from 'styles/colors'

import BaseButton from 'components/Button'

export const Container = styled.div`
    width: 100%;

    padding: 10px 0;
    font-size: 12px;

    text-align: center;

    > * + * {
        margin-top: 20px !important;
    }
`

export const Title = styled.h1`
    font-size: 22px;
    font-weight: 700;

    color: ${colors.darkGreen};
`

export const Subtitle = styled.h2`
    font-size: 16px;
    font-weight: 700;

    color: #733dc2;
`

export const Desc = styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;

    color: ${colors.gray_50};
`

export const List = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > * + * {
        margin-top: 10px;
    }
`

export const Item = styled.div`
    min-width: 170px;

    display: flex;

    align-items: center;

    font-size: 12px;
    font-weight: 300;

    > * + * {
        margin-left: 10px;
    }
`

export const Icon = styled.img`
    width: 50px;
    display: block;
    margin: 0 auto;
`

export const Button = styled(BaseButton)`
    width: 100%;
`

export const Name = styled.span`
    font-size: 14px;
    font-weight: 700;

    color: ${colors.gray_50};
`
